// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__1uL2n","Content":"Header_Content__2-Dc0","LogoContainer":"Header_LogoContainer__1NUmb","Logo":"Header_Logo___4UlH"};